import { absolutePath } from "@/react/helpers/urlHelpers/internalApi/absolutePath";

interface ParamsProps {
  params?: Record<string, unknown>;
}

interface IdProps {
  id: string;
}

export const invitationLinks = {
  index: (props?: ParamsProps) =>
    absolutePath("admin/invitation_links", props?.params),

  get: ({ id }: IdProps) => absolutePath(`admin/invitation_links/${id}`),

  create: (props?: ParamsProps) =>
    absolutePath("admin/invitation_links", props?.params),

  update: ({ id }: IdProps) => absolutePath(`admin/invitation_links/${id}`),

  revoke: ({ id }: IdProps) =>
    absolutePath(`admin/invitation_links/${id}/revoke`),

  reactivate: ({ id }: IdProps) =>
    absolutePath(`admin/invitation_links/${id}/reactivate`),

  destroy: ({ id }: IdProps) => absolutePath(`admin/invitation_links/${id}`),
};
